function formatDate(date) {
  let day = twoDigits(date.getDate());
  let month = twoDigits(date.getMonth() + 1);
  let year = date.getFullYear();

  return day + '/' + month + '/' + year;
}

function twoDigits(number) {
  if (number < 10)
    return '0' + number;
  return number;
}

export default {
  getFormFields: (state) => {
    let fields = Object.assign({}, state.poster.fields);

    if (typeof state.poster.content != 'undefined'){
      fields.content = state.poster.content;
    } else if (typeof state.selector.template != 'undefined') {
      fields.content = state.selector.template.content;
    }

    if (typeof state.selector.template != 'undefined') {
      fields.template_id = state.selector.template.id;
    }

    if (typeof state.selector.theme != 'undefined') {
      fields.theme_id = state.selector.theme.id;
    }

    fields.id = state.poster.id
    fields.sales_unit_id = state.poster.sales_unit_id;
    fields.sales_unit2_id = state.poster.sales_unit_id;
    fields.sales_unit3_id = state.poster.sales_unit_id;
    fields.product_id = state.poster.product_id;
    fields.department_id = state.poster.department_id;
    fields.update_price = state.poster.update_price;

    if (fields.product_code == ' ') {
      fields.product_code = null;
    }

    if (fields.valid_until) {
      let validUntil = new Date(fields.valid_until);
      fields.valid_until = formatDate(validUntil);
    }

    if (fields.valid_from) {
      let validFrom = new Date(fields.valid_from);
      fields.valid_from = formatDate(validFrom);
    }

    if (fields.validate) {
      let validate = new Date(fields.validate);
      fields.validate = formatDate(validate);
    }

    return fields;
  },
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/store/getters.js